export * as FieldHistoryStore from "./field-history"

export function list(recordID: string, fieldID: string) {
  return `/fieldHistory/${recordID}/${fieldID}/`
}
